module.exports = __webpack_public_path__ + "static/media/015.1920168b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/015.jpg
// module id = 559
// module chunks = 0